import { Tooltip } from '@mui/material'

import ChipStatus from 'packages/ui/ChipStatus'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'

import useLink from 'pages/Documents/hooks/use-link'

const Status = ({document}) => {
  const {t } = useTranslation()
  return (
    <ChipStatus status={t(`audin_document.status.${document.step === 'validated' ? 'validated_one' : 'in_progress'}`)}
                color={document.step === 'validated' ? '#547231' : '#7A8096'}
                bgcolor={document.step === 'validated' ? '#E1EDD4' : '#F6F7F8'} />
  )
}

const ActionsDocument = ({document}) => {
  const {t } = useTranslation()
  const apiLink = useLink()
  return document.step === 'validated' ? (
    <Tooltip title={t('projects.document.tooltip.validated')} placement={'top'} arrow>
      <i
        className={'fa-light fa-eye'}
        style={{fontSize: 12, cursor: 'pointer'}}
        onClick={async () => {
          await apiLink.go(document.id)
        }}
      />
    </Tooltip>
  ) : null
}

export const COLUMNS_CONFIG_DOCUMENTS = [
  {
    name: 'status',
    header: {
      label: ctx => ctx.t('projects.document.table.status_col')
    },
    value: document => <Status document={document} />
  },
  {
    name: 'label',
    header: {
      label: ctx => ctx.t('projects.document.table.label_col')
    },
    value: document => document.name
  },
  {
    name: 'type',
    header: {
      label: ctx => ctx.t('projects.document.table.type_col')
    },
    value: (item, ctx) => ctx.t(`audin_document.report_type.${item.type.toLowerCase()}`)
  },
  {
    name: 'createdAt',
    header: {
      label: ctx => ctx.t('projects.document.table.created_at_col'),
    },
    value: (document) => new Date(document.created_at).toLocaleDateString(i18next.language)
  },
  {
    name: 'updatedAt',
    header: {
      label: ctx => ctx.t('projects.document.table.updated_at_col'),
    },
    value: (document) => new Date(document.updated_at).toLocaleDateString(i18next.language)
  },
  {
    name: 'actions',
    header: {
      label: () => ''
    },
    value: (document) => <ActionsDocument document={document} />
  }
]

const COLUMNS_CONFIG_CONTACTS = [
  {
    name: 'firstName',
    header: {
      label: ctx => ctx.t('projects.contact.table.first_name_col')
    },
    value: contact => contact.first_name
  },
  {
    name: 'lastName',
    header: {
      label: ctx => ctx.t('projects.contact.table.last_name_col')
    },
    value: contact => contact.last_name
  },
  {
    name: 'title',
    header: {
      label: ctx => ctx.t('projects.contact.table.title_col')
    },
    value: contact => contact.title
  },
  {
    name: 'email',
    header: {
      label: ctx => ctx.t('projects.contact.table.email_col')
    },
    value: contact => contact.email
  },
  {
    name: 'phone',
    header: {
      label: ctx => ctx.t('projects.contact.table.phone_col')
    },
    value: contact => contact.phone || contact.mobile_phone
  }
]

export default COLUMNS_CONFIG_CONTACTS
